const COLUMNSLIST = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '文件名称'
  },
  dataIndex: 'name',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '变量类型'
  },
  dataIndex: 'type',
  key: '3',
  align: 'center',
  width: 150,
  scopedSlots: {
    customRender: 'type'
  }
}, {
  slots: {
    title: '承保单位'
  },
  dataIndex: 'unitName',
  key: '4',
  align: 'center'
  // scopedSlots: {customRender: 'unitName'},
  // ellipsis: true,
  // customRender: (text) => (
  //   <a-tooltip placement="topLeft" title={{text}}>
  //     {{text}}
  //   </a-tooltip>
  // )
}, {
  slots: {
    title: '状态'
  },
  width: 100,
  dataIndex: 'status',
  key: '6',
  align: 'center',
  scopedSlots: {
    customRender: 'status'
  }
}, {
  slots: {
    title: '创建时间'
  },
  dataIndex: 'createAt',
  key: '7',
  align: 'center',
  width: 200
}, {
  slots: {
    title: '操作'
  },
  width: 150,
  key: '8',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  }
}];
const TYPE = [{
  name: '客户告知书',
  id: 'CUSTOMER_NOTIFICATION'
}, {
  name: '隐私政策',
  id: 'PRIVACY_POLICY'
}, {
  name: '投保须知',
  id: 'NOTICE_TO_INSURE'
}, {
  name: '用户协议',
  id: 'USER_AGREEMENT'
}, {
  name: '责任免除',
  id: 'DISCLAIMER_AGREEMENT'
}];
export { COLUMNSLIST, TYPE };